import { VStack } from "@chakra-ui/react";
import React from "react";
import FormQuoteSummary from "../common-quote/FormQuoteSummary";
import FormSfActions from "../common-quote/FormSfActions";
import FormCalcSummary from "../common-quote/FormCalcSummary";
import { QuoteFormActions } from "../../lib/types/QuoteFormActions";
import { CalculationType } from "../../state/quote-reducer";

export interface QuoteSummaryBarProps {
  formActionHandler: (action: QuoteFormActions, formValues: any) => void;
  calculation: CalculationType;
}

const QuoteSummaryBar = (props: QuoteSummaryBarProps) => {
  return (
    <VStack
      display={{ base: "none", lg: "block" }}
      position="sticky"
      top={2}
      spacing={8}
      width="300px"
      marginLeft={{ base: 8, lg: 4, xl: 8 }}
      height="calc(100vh - 75px)"
      overflow="auto"
    >
      <FormQuoteSummary handler={props.formActionHandler} />
      <FormSfActions handler={props.formActionHandler} />
      {props.calculation && <FormCalcSummary />}
    </VStack>
  );
};

export default QuoteSummaryBar;
